<curafida-card
    #curafidaCardComponent
    (setActionButton)="addNewTags()"
    [actionButtons]="actionButtons()"
    [title]="title"
    class="full-width no-left-right-margin">
    <ion-card-content class="tagCategoryContainer">
        @for (tagCategory of tagCategories(); track tagCategory.uuid) {
            <div class="tagCategory">
                <ion-label>
                    {{ tagCategory.label }}
                </ion-label>
                <div class="tags">
                    @for (tag of tagCategory.tags; track tag.uuid) {
                        <ion-chip
                            (click)="removeTag(tag)"
                            [class.no-click]="!isEditEnabled()"
                            [class.no-pointer]="!isEditEnabled()"
                            [outline]="true"
                            color="primary">
                            <ion-label>{{ tag.label }}&nbsp;</ion-label>
                            @if (isEditEnabled()) {
                                <ion-icon
                                    class="pointer"
                                    name="close"></ion-icon>
                            }
                        </ion-chip>
                    }
                </div>
            </div>
        } @empty {
            {{ 'TAG.NONE' | translate }}
        }
        @if (!isButtonHidden() && !isNewElement()) {
            <div class="flex-container-row justify-content-flex-end">
                @if (isEditEnabled()) {
                    <ion-button
                        (click)="cancelEdit()"
                        data-testid="user-tag-cancel-edit"
                        [class.btn-font-medium]="!isMobile()"
                        [class.half-width]="isMobile()"
                        color="danger">
                        {{ 'CANCEL_EDIT' | translate }}
                    </ion-button>
                } @else {
                    <ion-button
                        (click)="toggleEdit()"
                        data-testid="user-tag-edit"
                        [class.btn-font-medium]="!isMobile()"
                        [class.full-width]="isMobile()">
                        {{ 'EDIT' | translate }}
                    </ion-button>
                }
            </div>
        }
    </ion-card-content>
</curafida-card>
